export default function Marquee({ items }) {
  const list = items && items.length ? items : ["EDITORIAL", "CANDOUR", "TRUTH", "UNVARNISHED"];
  const doubled = [...list, ...list, ...list, ...list];
  return (
    <div className="border-t-ink border-b-ink bg-[#0A0A0A] text-[#F4F4F0] overflow-hidden" data-testid="marquee">
      <div className="marquee-track py-3">
        {doubled.map((s, i) => (
          <span key={i} className="font-display italic text-[22px] md:text-[26px] px-8">
            {s} <span className="text-[#FF3333] mx-3">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
